import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardCard } from '@app/shared/services/dashboard.service';

@Component({
  standalone: false,
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent implements OnInit {
  @Input() defaultCard: DashboardCard;
  @Input() card?: DashboardCard;

  @Output() editCardRequested: EventEmitter<DashboardCard> = new EventEmitter<DashboardCard>();
  @Output() addCardRequested: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
